export default __webpack_public_path__ + "static/media/photo--lg--3.14bcd2eb.jpg";